<template>
  <div>
    <div class="list-agents">
      <div class="avatar-team" :class="[avatars.length > 2 ? 'full' : '']">
        <div class="avatar-agent" v-for="avatarURL in avatars" :key="avatarURL">
          <img :src="avatarURL || defaultAvatar" alt="">
        </div>
      </div>
    </div>

    <div class="team-intro">
      <p v-html="teamIntro"></p>
      <h4 v-if="replyTime > 0">{{ $t("reply_time", { '0': replyTime + 's' }) }}</h4>
    </div>
  </div>
</template>

<script>
import { u as umbrella } from 'umbrellajs'
import { excludeBots } from '../utils'

const objectPath = require('object-path')

export default {
  name: 'account-profile',

  computed: {
    avatars () {
      let avatars = []
      const agents = excludeBots(this.$store.state.agents)

      for (var agent of agents) {
        avatars.push(agent.avatar_url)
      }

      // limit 3
      avatars = avatars.slice(0, 3)
      return avatars
    },

    defaultAvatar () {
      return this.$store.state.defaultAvatar
    },

    replyTime () {
      return objectPath.get(this.$store.state, 'accountSetting.replytime', 0)
    },

    teamIntro () {
      return this.$i18n.t('team_intro')
    }
  },

  mounted () {
    const el = umbrella(this.$el)
    el.find('a').each((node, i) => {
      umbrella(node).attr('target', '_blank')
    })
  }
}
</script>
